import * as React from "react";

const AddNewGroup = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={77} height={64} viewBox="0 0 77 64" fill="none" {...props}>
    <path
      d="M14.39 45.358c-.839-8.947-3.088-17.017-5.82-23.823-1.64-4.083-1.45-9.156.115-13.252 1.571-4.114 4.444-7.058 8.037-7.23 12.228-.58 27.34-.655 37.56 1.502 7.687 1.624 12.923 8.412 16.4 17.031 3.466 8.597 5.116 18.86 5.72 27.131.403 5.513-3.394 9.724-7.85 9.724H23.761c-2.42 0-4.608-1.229-6.281-3.248-1.675-2.021-2.807-4.81-3.09-7.834Z"
      stroke="#A5ADAC"
      strokeOpacity={0.5}
      strokeWidth={1.137}
    />
    <path
      d="M6.969 52.268c-.833-8.885-3.067-16.901-5.781-23.663-3.4-8.47.812-20.89 8.652-21.262 12.228-.582 27.406-.662 37.704 1.512 15.945 3.367 21.358 28.073 22.571 44.677.422 5.78-3.572 10.334-8.417 10.334H16.907c-5.254 0-9.352-5.345-9.938-11.598"
      fill="#fff"
    />
    <path
      d="M7.535 52.215c-.838-8.947-3.087-17.017-5.82-23.822-1.639-4.084-1.45-9.156.115-13.253 1.572-4.114 4.445-7.058 8.037-7.23 12.229-.58 27.34-.656 37.56 1.502 7.688 1.623 12.924 8.411 16.4 17.03 3.467 8.597 5.117 18.86 5.72 27.132.403 5.512-3.394 9.723-7.85 9.723h-44.79c-2.42 0-4.609-1.228-6.281-3.248-1.675-2.021-2.807-4.81-3.09-7.834Z"
      stroke="#A5ADAC"
      strokeOpacity={0.5}
      strokeWidth={1.137}
    />
    <path
      d="M32.662 25.688c0-.496.402-.898.898-.898h1.931c.496 0 .899.402.899.898v21.81a.9.9 0 0 1-.898.899H33.56a.9.9 0 0 1-.898-.898z"
      fill="#000"
      fillOpacity={0.41}
    />
    <path
      d="M22.722 35.63c0-.496.402-.898.898-.898h21.81c.496 0 .898.402.898.898v1.931a.9.9 0 0 1-.898.898H23.62a.9.9 0 0 1-.898-.898z"
      fill="#000"
      fillOpacity={0.41}
    />
  </svg>
);

const GroupIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={81} height={74} viewBox="0 0 81 74" fill="none" {...props}>
    <path
      d="M18.877.721c-5.838 0-10.57 4.733-10.57 10.57v42c0 5.838 4.732 10.57 10.57 10.57h50.65c5.837 0 10.57-4.732 10.57-10.57v-45a7.57 7.57 0 0 0-7.57-7.57z"
      stroke="#A5ADAC"
      strokeOpacity={0.5}
      strokeWidth={1.14}
    />
    <path
      d="M1.876 20.291c0-5.523 4.478-10 10-10h53.65a7 7 0 0 1 7 7v45c0 5.523-4.477 10-10 10h-50.65c-5.522 0-10-4.477-10-10z"
      fill="#fff"
    />
    <path
      d="M11.877 9.721c-5.838 0-10.57 4.733-10.57 10.57v42c0 5.838 4.732 10.57 10.57 10.57h50.65c5.837 0 10.57-4.732 10.57-10.57v-45a7.57 7.57 0 0 0-7.57-7.57z"
      stroke="#A5ADAC"
      strokeOpacity={0.5}
      strokeWidth={1.14}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.986 26.062h17.73a6.7 6.7 0 0 1 3.496.975L23.649 52.145a6.72 6.72 0 0 1-1.416-4.138V32.815a6.75 6.75 0 0 1 6.753-6.753m-5.322 29.553a9.24 9.24 0 0 0 5.322 1.676h17.73A9.284 9.284 0 0 0 56 48.007V32.815a9.284 9.284 0 0 0-9.284-9.285h-17.73a9.284 9.284 0 0 0-9.285 9.285v15.192a9.27 9.27 0 0 0 3.53 7.286l.365.386zm1.893-1.79L52.1 28.738a6.72 6.72 0 0 1 1.369 4.077v15.192a6.75 6.75 0 0 1-6.752 6.752h-17.73a6.7 6.7 0 0 1-3.428-.934"
      fill="#000"
      fillOpacity={0.41}
    />
  </svg>
);

const OrderPayment = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={170} height={118} viewBox="0 0 170 118" fill="none" {...props}>
    <path
      d="M64.8097 117.378H131.805C134.418 117.378 136.875 116.35 138.722 114.503C140.587 112.638 141.615 110.182 141.615 107.568C141.615 102.184 137.241 97.8105 131.857 97.7756H64.74C59.3734 97.8105 55 102.184 55 107.568C55 110.182 56.028 112.638 57.875 114.503C59.7393 116.35 62.1961 117.378 64.8097 117.378ZM120.113 105.826H125.253C126.212 105.826 126.996 106.61 126.996 107.568C126.996 108.526 126.212 109.31 125.253 109.31H120.113C119.155 109.31 118.371 108.526 118.371 107.568C118.371 106.61 119.155 105.826 120.113 105.826ZM71.3611 105.826H110.129C111.105 105.826 111.872 106.61 111.872 107.568C111.872 108.526 111.105 109.31 110.129 109.31H71.3611C70.4028 109.31 69.6187 108.526 69.6187 107.568C69.6187 106.61 70.4028 105.826 71.3611 105.826Z"
      fill="url(#paint0_linear_1678_20039)"
    />
    <path
      d="M64.8097 117.378H131.805C134.418 117.378 136.875 116.35 138.722 114.503C140.587 112.638 141.615 110.182 141.615 107.568C141.615 102.184 137.241 97.8105 131.857 97.7756H64.74C59.3734 97.8105 55 102.184 55 107.568C55 110.182 56.028 112.638 57.875 114.503C59.7393 116.35 62.1961 117.378 64.8097 117.378ZM120.113 105.826H125.253C126.212 105.826 126.996 106.61 126.996 107.568C126.996 108.526 126.212 109.31 125.253 109.31H120.113C119.155 109.31 118.371 108.526 118.371 107.568C118.371 106.61 119.155 105.826 120.113 105.826ZM71.3611 105.826H110.129C111.105 105.826 111.872 106.61 111.872 107.568C111.872 108.526 111.105 109.31 110.129 109.31H71.3611C70.4028 109.31 69.6187 108.526 69.6187 107.568C69.6187 106.61 70.4028 105.826 71.3611 105.826Z"
      fill="black"
      fillOpacity={0.1}
    />
    <path
      d="M64.7574 94.2907C64.7749 94.2907 64.7923 94.2733 64.8097 94.2733H131.805C131.822 94.2733 131.822 94.2907 131.84 94.2907C134.436 94.2733 136.893 93.2627 138.722 91.4157C139.071 91.0673 139.349 90.6839 139.646 90.3006C139.75 90.1612 139.872 90.0392 139.977 89.8824C140.221 89.5165 140.412 89.1158 140.604 88.715C140.691 88.5408 140.796 88.384 140.865 88.2097C141.022 87.8264 141.127 87.4082 141.231 87.0075C141.284 86.7984 141.371 86.6067 141.423 86.3802C141.527 85.8575 141.562 85.2999 141.58 84.7424C141.58 84.6552 141.597 84.5681 141.597 84.481C141.597 79.0796 137.206 74.6887 131.805 74.6887H64.8097C59.3908 74.6887 55 79.0796 55 84.481C55 87.0946 56.028 89.5514 57.875 91.4157C59.7219 93.2627 62.1613 94.2733 64.7574 94.2907ZM91.6078 82.7386H125.253C126.212 82.7386 126.996 83.5227 126.996 84.481C126.996 85.4393 126.212 86.2234 125.253 86.2234H91.6078C90.6495 86.2234 89.8654 85.4393 89.8654 84.481C89.8654 83.5227 90.6495 82.7386 91.6078 82.7386ZM72.5808 82.7909H79.2193C80.1776 82.7909 80.9617 83.5749 80.9617 84.5333C80.9617 85.4916 80.1776 86.2757 79.2193 86.2757H72.5808C71.6051 86.2757 70.8384 85.4916 70.8384 84.5333C70.8384 83.5749 71.6051 82.7909 72.5808 82.7909Z"
      fill="url(#paint1_linear_1678_20039)"
    />
    <path
      d="M64.7574 94.2907C64.7749 94.2907 64.7923 94.2733 64.8097 94.2733H131.805C131.822 94.2733 131.822 94.2907 131.84 94.2907C134.436 94.2733 136.893 93.2627 138.722 91.4157C139.071 91.0673 139.349 90.6839 139.646 90.3006C139.75 90.1612 139.872 90.0392 139.977 89.8824C140.221 89.5165 140.412 89.1158 140.604 88.715C140.691 88.5408 140.796 88.384 140.865 88.2097C141.022 87.8264 141.127 87.4082 141.231 87.0075C141.284 86.7984 141.371 86.6067 141.423 86.3802C141.527 85.8575 141.562 85.2999 141.58 84.7424C141.58 84.6552 141.597 84.5681 141.597 84.481C141.597 79.0796 137.206 74.6887 131.805 74.6887H64.8097C59.3908 74.6887 55 79.0796 55 84.481C55 87.0946 56.028 89.5514 57.875 91.4157C59.7219 93.2627 62.1613 94.2733 64.7574 94.2907ZM91.6078 82.7386H125.253C126.212 82.7386 126.996 83.5227 126.996 84.481C126.996 85.4393 126.212 86.2234 125.253 86.2234H91.6078C90.6495 86.2234 89.8654 85.4393 89.8654 84.481C89.8654 83.5227 90.6495 82.7386 91.6078 82.7386ZM72.5808 82.7909H79.2193C80.1776 82.7909 80.9617 83.5749 80.9617 84.5333C80.9617 85.4916 80.1776 86.2757 79.2193 86.2757H72.5808C71.6051 86.2757 70.8384 85.4916 70.8384 84.5333C70.8384 83.5749 71.6051 82.7909 72.5808 82.7909Z"
      fill="black"
      fillOpacity={0.1}
    />
    <path
      d="M159.178 55H103.7C99.1694 55 94.7088 56.2023 90.771 58.4499L68.5554 71.2043H131.804C139.123 71.2043 145.082 77.1459 145.082 84.4814H145.099C145.099 84.5859 145.082 84.6905 145.082 84.795C145.064 85.1261 145.064 85.4571 145.029 85.7882C145.012 86.0147 144.96 86.2238 144.925 86.4503C144.907 86.6419 144.89 86.8162 144.855 87.0079L164.649 72.6156C167.018 70.9081 168.517 68.2422 168.761 65.315C169.005 62.4749 168.046 59.7916 166.095 57.7878L165.955 57.6659C164.265 55.9757 161.791 55 159.178 55Z"
      fill="url(#paint2_linear_1678_20039)"
    />
    <path
      d="M159.178 55H103.7C99.1694 55 94.7088 56.2023 90.771 58.4499L68.5554 71.2043H131.804C139.123 71.2043 145.082 77.1459 145.082 84.4814H145.099C145.099 84.5859 145.082 84.6905 145.082 84.795C145.064 85.1261 145.064 85.4571 145.029 85.7882C145.012 86.0147 144.96 86.2238 144.925 86.4503C144.907 86.6419 144.89 86.8162 144.855 87.0079L164.649 72.6156C167.018 70.9081 168.517 68.2422 168.761 65.315C169.005 62.4749 168.046 59.7916 166.095 57.7878L165.955 57.6659C164.265 55.9757 161.791 55 159.178 55Z"
      fill="black"
      fillOpacity={0.1}
    />
    <path
      d="M169.963 87.7743C170.207 84.9691 169.231 82.2335 167.297 80.2646L167.158 80.1252C166.112 79.0623 164.771 78.3305 163.29 77.9124L140.743 94.2909C140.726 94.3083 140.726 94.3083 140.708 94.3083C139.976 94.9704 139.192 95.5454 138.356 96.0333C142.381 98.3158 145.099 102.62 145.099 107.568C145.099 108.439 145.012 109.293 144.838 110.112L165.851 95.075C168.221 93.3674 169.719 90.7016 169.963 87.7743Z"
      fill="url(#paint3_linear_1678_20039)"
    />
    <path
      d="M169.963 87.7743C170.207 84.9691 169.231 82.2335 167.297 80.2646L167.158 80.1252C166.112 79.0623 164.771 78.3305 163.29 77.9124L140.743 94.2909C140.726 94.3083 140.726 94.3083 140.708 94.3083C139.976 94.9704 139.192 95.5454 138.356 96.0333C142.381 98.3158 145.099 102.62 145.099 107.568C145.099 108.439 145.012 109.293 144.838 110.112L165.851 95.075C168.221 93.3674 169.719 90.7016 169.963 87.7743Z"
      fill="black"
      fillOpacity={0.1}
    />
    <path
      d="M5.58325 12.5625H24.4476C26.6687 12.5625 28.799 13.4449 30.3696 15.0155L39.0833 23.7292"
      stroke="url(#paint4_linear_1678_20039)"
      strokeWidth={4.1875}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9583 37.6875H5.58325"
      stroke="url(#paint5_linear_1678_20039)"
      strokeWidth={4.1875}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7291 20.9375L29.3124 26.5208C30.8543 28.0627 30.8543 30.5623 29.3124 32.1042C27.7706 33.646 25.2709 33.646 23.7291 32.1042L19.5416 27.9167C17.1388 30.3195 13.3349 30.5897 10.6165 28.5509L9.77075 27.9167"
      stroke="url(#paint6_linear_1678_20039)"
      strokeWidth={4.1875}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9583 30.7072V43.2697C13.9583 48.5337 13.9583 51.1656 15.5936 52.801C17.2289 54.4364 19.8609 54.4364 25.1249 54.4364H50.2499C55.5139 54.4364 58.1459 54.4364 59.7812 52.801C61.4166 51.1656 61.4166 48.5337 61.4166 43.2697V34.8947C61.4166 29.6307 61.4166 26.9987 59.7812 25.3634C58.1459 23.728 55.5139 23.728 50.2499 23.728H26.5208"
      stroke="url(#paint7_linear_1678_20039)"
      strokeWidth={4.1875}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.5728 39.0822C42.5728 41.7803 40.3856 43.9676 37.6874 43.9676C34.9893 43.9676 32.802 41.7803 32.802 39.0822C32.802 36.384 34.9893 34.1968 37.6874 34.1968C40.3856 34.1968 42.5728 36.384 42.5728 39.0822Z"
      stroke="url(#paint8_linear_1678_20039)"
      strokeWidth={4.1875}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1678_20039"
        x1={72.7955}
        y1={97.7756}
        x2={79.7874}
        y2={132.389}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1678_20039"
        x1={72.7919}
        y1={74.6887}
        x2={79.7851}
        y2={109.301}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1678_20039"
        x1={89.1509}
        y1={55}
        x2={104.657}
        y2={109.406}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1678_20039"
        x1={144.857}
        y1={77.9124}
        x2={174.31}
        y2={110.34}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1678_20039"
        x1={22.3333}
        y1={12.5625}
        x2={27.9734}
        y2={24.8451}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37645D" />
        <stop offset={1} stopColor="#0A7463" stopOpacity={0.88} />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1678_20039"
        x1={9.77075}
        y1={37.6875}
        x2={9.98406}
        y2={38.9843}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37645D" />
        <stop offset={1} stopColor="#0A7463" stopOpacity={0.88} />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1678_20039"
        x1={20.1198}
        y1={20.9375}
        x2={28.1675}
        y2={30.7496}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37645D" />
        <stop offset={1} stopColor="#0A7463" stopOpacity={0.88} />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1678_20039"
        x1={37.6874}
        y1={23.728}
        x2={58.0028}
        y2={46.5188}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37645D" />
        <stop offset={1} stopColor="#0A7463" stopOpacity={0.88} />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1678_20039"
        x1={37.6874}
        y1={34.1968}
        x2={43.874}
        y2={38.6876}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37645D" />
        <stop offset={1} stopColor="#0A7463" stopOpacity={0.88} />
      </linearGradient>
    </defs>
  </svg>
);

const Pencil = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={17} height={17} viewBox="0 0 17 17" fill="none" {...props}>
    <path
      d="m12.038 3.705 1.124-1.125a1.25 1.25 0 1 1 1.768 1.768l-9.577 9.577a3 3 0 0 1-1.265.753l-1.79.533.534-1.79a3 3 0 0 1 .753-1.264zm0 0 1.758 1.758"
      stroke="#71717A"
      strokeWidth={0.96}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Trash = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={17} height={17} viewBox="0 0 17 17" fill="none" {...props}>
    <g
      clipPath="url(#a)"
      stroke="#71717A"
      strokeWidth={1.5}
      strokeLinecap="round"
    >
      <path d="m13.59 4.38-.413 6.683c-.106 1.707-.159 2.561-.587 3.175-.211.303-.484.56-.8.752-.639.39-1.494.39-3.205.39-1.713 0-2.57 0-3.21-.39a2.7 2.7 0 0 1-.8-.754c-.427-.615-.48-1.47-.582-3.18L3.59 4.38m-1 0h12m-3.297 0-.455-.94c-.302-.623-.453-.935-.714-1.13a1.3 1.3 0 0 0-.183-.114c-.289-.15-.635-.15-1.328-.15-.71 0-1.066 0-1.36.156a1.3 1.3 0 0 0-.185.12c-.264.202-.411.525-.706 1.171l-.404.886m.965 7.334v-4m3.333 4v-4" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.59.713h16v16h-16z" />
      </clipPath>
    </defs>
  </svg>
);

export { AddNewGroup, GroupIcon, OrderPayment, Pencil, Trash };
